import React from "react";

export const FlickLogo = () => {
  return (
    <svg
      width="98px"
      height="31px"
      viewBox="0 0 98 31"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g stroke="none" strokeWidth="1" fill="#000000" fillRule="nonzero">
        <polygon points="19.93 0.447 19.93 6.404 9.408 6.404 9.408 9.056 19.182 9.056 19.182 14.477 9.408 14.477 9.408 19.119 12.295 19.119 4.634 30.926 4.634 21.299 2.317 21.299 2.317 12.493 0 12.493 0 0.447"></polygon>
        <path d="M63.994,0 C68.596,0 71.704,2.234 73.467,5.42 L67.7,8.785 C66.923,7.296 65.817,6.254 63.904,6.254 C61.544,6.254 59.99,8.309 59.99,10.81 L59.99,10.87 C59.99,13.58 61.603,15.486 63.904,15.486 C65.877,15.486 66.982,14.414 67.849,12.866 L73.617,16.111 C71.854,19.209 68.925,21.741 63.725,21.741 C57.928,21.741 52.877,17.392 52.877,10.93 L52.877,10.87 C52.877,4.646 57.75,0 63.994,0 Z"></path>
        <polygon points="30.021 0.447 30.021 15.337 39.853 15.337 39.853 21.293 23.03 21.293 23.03 0.447 30.022 0.447"></polygon>
        <polygon points="49.945 0.447 49.945 21.293 42.952 21.293 42.952 0.447"></polygon>
        <polygon points="83.747 0.447 83.747 8.249 89.694 0.447 97.822 0.447 90.531 9.5 97.971 21.293 89.634 21.293 85.54 14.682 83.747 16.856 83.747 21.293 76.754 21.293 76.754 0.447"></polygon>
      </g>
    </svg>
  );
};

export default FlickLogo;
